export default __webpack_public_path__ + "static/media/villa_8.cc62829f.jpg";